/* eslint-disable import/prefer-default-export */
export const GET_SCHOOLS_ERROR = 'GET_SCHOOLS_ERROR';
export const GET_SCHOOLS_START = 'GET_SCHOOLS_START';
export const GET_SCHOOLS_SUCCESS = 'GET_SCHOOLS_SUCCESS';
export const SET_LOCALE_SUCCESS = 'SET_LOCALE_SUCCESS';
export const SET_RUNTIME_VARIABLE = 'SET_RUNTIME_VARIABLE';
export const PAGE_UP = 'PAGE_UP';
export const PAGE_DOWN = 'PAGE_DOWN';
export const RESET_PAGINATION = 'RESET_PAGINATION';
export const SET_LAST_PAGE = 'SET_LAST_PAGE';
export const UNSET_LAST_PAGE = 'UNSET_LAST_PAGE';
export const SHOW_DETAILS = 'SHOW_DETAILS';
export const SAVE_PROGRAM_START = 'SAVE_PROGRAM_START';
export const SAVE_PROGRAM_SUCCESS = 'SAVE_PROGRAM_SUCCESS';
export const SAVE_PROGRAM_ERROR = 'SAVE_PROGRAM_ERROR';
export const DELETE_PROGRAM_START = 'DELETE_PROGRAM_START';
export const DELETE_PROGRAM_SUCCESS = 'DELETE_PROGRAM_SUCCESS';
export const DELETE_PROGRAM_ERROR = 'DELETE_PROGRAM_ERROR';
export const GET_STUDENT_START = 'GET_STUDENT_START';
export const GET_STUDENT_SUCCESS = 'GET_STUDENT_SUCCESS';
export const GET_STUDENT_ERROR = 'GET_STUDENT_ERROR';
export const GET_STUDENTINFO_START = 'GET_STUDENTINFO_START';
export const GET_STUDENTINFO_SUCCESS = 'GET_STUDENTINFO_SUCCESS';
export const GET_STUDENTINFO_ERROR = 'GET_STUDENTINFO_ERROR';
export const SAVE_APPLICATION_START = 'SAVE_APPLICATION_START';
export const SAVE_APPLICATION_SUCCESS = 'SAVE_APPLICATION_SUCCESS';
export const SAVE_APPLICATION_ERROR = 'SAVE_APPLICATION_ERROR';
export const DELETE_APPLICATION_START = 'DELETE_APPLICATION_START';
export const DELETE_APPLICATION_SUCCESS = 'DELETE_APPLICATION_SUCCESS';
export const DELETE_APPLICATION_ERROR = 'DELETE_APPLICATION_ERROR';
export const GET_FILTERS_START = 'GET_FILTERS_START';
export const GET_FILTERS_SUCCESS = 'GET_FILTERS_SUCCESS';
export const GET_FILTERS_ERROR = 'GET_FILTERS_ERROR';
export const APPLY_FILTERS = 'APPLY_FILTERS';
export const SCHOOL_HOVER = 'SCHOOL_HOVER';
export const FETCH_SCHEDULE_START = 'FETCH_SCHEDULE_START';
export const FETCH_SCHEDULE_SUCCESS = 'FETCH_SCHEDULE_SUCCESS';
export const FETCH_SCHEDULE_ERROR = 'FETCH_SCHEDULE_ERROR';
export const FETCH_APPOINTMENTS_START = 'FETCH_APPOINTMENTS_START';
export const FETCH_APPOINTMENTS_SUCCESS = 'FETCH_APPOINTMENTS_SUCCESS';
export const FETCH_APPOINTMENTS_ERROR = 'FETCH_APPOINTMENTS_ERROR';
export const FETCH_STUDENT_APPOINTMENTS_START = 'FETCH_STUDENT_APPOINTMENTS_START';
export const FETCH_STUDENT_APPOINTMENTS_SUCCESS = 'FETCH_STUDENT_APPOINTMENTS_SUCCESS';
export const FETCH_STUDENT_APPOINTMENTS_ERROR = 'FETCH_STUDENT_APPOINTMENTS_ERROR';
export const MAKE_APPOINTMENT_START = 'MAKE_APPOINTMENT_START';
export const MAKE_APPOINTMENT_SUCCESS = 'MAKE_APPOINTMENT_SUCCESS';
export const MAKE_APPOINTMENT_ERROR = 'MAKE_APPOINTMENT_ERROR';
export const MAKE_APPOINTMENT_RESET = 'MAKE_APPOINTMENT_RESET';
export const CANCEL_APPOINTMENT_START = 'CANCEL_APPOINTMENT_START';
export const CANCEL_APPOINTMENT_SUCCESS = 'CANCEL_APPOINTMENT_SUCCESS';
export const CANCEL_APPOINTMENT_ERROR = 'CANCEL_APPOINTMENT_ERROR';
export const CANCEL_APPOINTMENT_RESET = 'CANCEL_APPOINTMENT_RESET';
export const UPDATE_APPOINTMENT_START = 'UPDATE_APPOINTMENT_START';
export const UPDATE_APPOINTMENT_SUCCESS = 'UPDATE_APPOINTMENT_SUCCESS';
export const UPDATE_APPOINTMENT_ERROR = 'UPDATE_APPOINTMENT_ERROR';
export const UPDATE_APPOINTMENT_RESET = 'UPDATE_APPOINTMENT_RESET';
export const EXPRESS_INTEREST_START = 'EXPRESS_INTEREST_START';
export const EXPRESS_INTEREST_SUCCESS = 'EXPRESS_INTEREST_SUCCESS';
export const EXPRESS_INTEREST_ERROR = 'EXPRESS_INTEREST_ERROR';
export const EXPRESS_INTEREST_RESET = 'EXPRESS_INTEREST_RESET';
export const FETCH_EXPRESSED_INTERESTS_INSTRUMENTS_START = 'FETCH_EXPRESSED_INTERESTS_INSTRUMENTS_START';
export const FETCH_EXPRESSED_INTERESTS_INSTRUMENTS_SUCCESS = 'FETCH_EXPRESSED_INTERESTS_INSTRUMENTS_SUCCESS';
export const FETCH_EXPRESSED_INTERESTS_INSTRUMENTS_ERROR = 'FETCH_EXPRESSED_INTERESTS_INSTRUMENTS_ERROR';
export const UNEXPRESS_INTEREST_START = 'UNEXPRESS_INTEREST_START';
export const UNEXPRESS_INTEREST_SUCCESS = 'UNEXPRESS_INTEREST_SUCCESS';
export const UNEXPRESS_INTEREST_ERROR = 'UNEXPRESS_INTEREST_ERROR';
export const UNEXPRESS_INTEREST_RESET = 'UNEXPRESS_INTEREST_RESET';
export const FETCH_EXPRESSED_INTERESTS_START = 'FETCH_EXPRESSED_INTERESTS_START';
export const FETCH_EXPRESSED_INTERESTS_SUCCESS = 'FETCH_EXPRESSED_INTERESTS_SUCCESS';
export const FETCH_EXPRESSED_INTERESTS_ERROR = 'FETCH_EXPRESSED_INTERESTS_ERROR';
export const SET_CUSTOM_FILTERS = 'SET_CUSTOM_FILTERS';
export const RESET_CUSTOM_FILTERS = 'RESET_CUSTOM_FILTERS';
export const FETCH_SHARED_SCHEDULE_START = 'FETCH_SHARED_SCHEDULE_START';
export const FETCH_SHARED_SCHEDULE_SUCCESS = 'FETCH_SHARED_SCHEDULE_SUCCESS';
export const FETCH_SHARED_SCHEDULE_ERROR = 'FETCH_SHARED_SCHEDULE_ERROR';
export const FETCH_SHARED_SCHEDULE_GT_FILTERED_START = 'FETCH_SHARED_SCHEDULE_GT_FILTERED_START';
export const FETCH_SHARED_SCHEDULE_GT_FILTERED_SUCCESS = 'FETCH_SHARED_SCHEDULE_GT_FILTERED_SUCCESS';
export const FETCH_SHARED_SCHEDULE_GT_FILTERED_ERROR = 'FETCH_SHARED_SCHEDULE_GT_FILTERED_ERROR';
export const FETCH_SHARED_SCHEDULE_GT_FILTERED_LOCATIONS_START = 'FETCH_SHARED_SCHEDULE_GT_FILTERED_LOCATIONS_START';
export const FETCH_SHARED_SCHEDULE_GT_FILTERED_LOCATIONS_SUCCESS =
  'FETCH_SHARED_SCHEDULE_GT_FILTERED_LOCATIONS_SUCCESS';
export const FETCH_SHARED_SCHEDULE_GT_FILTERED_LOCATIONS_ERROR = 'FETCH_SHARED_SCHEDULE_GT_FILTERED_LOCATIONS_ERROR';
export const NO_MATCHING_TIMESLOT_START = 'NO_MATCHING_TIMESLOT_START';
export const NO_MATCHING_TIMESLOT_SUCCESS = 'NO_MATCHING_TIMESLOT_SUCCESS';
export const NO_MATCHING_TIMESLOT_ERROR = 'NO_MATCHING_TIMESLOT_ERROR';
export const NO_MATCHING_TIMESLOT_RESET = 'NO_MATCHING_TIMESLOT_RESET';
export const SCHEDULE_COMPLETE_START = 'SCHEDULE_COMPLETE_START';
export const SCHEDULE_COMPLETE_SUCCESS = 'SCHEDULE_COMPLETE_SUCCESS';
export const SCHEDULE_COMPLETE_ERROR = 'SCHEDULE_COMPLETE_ERROR';
export const FETCH_NO_MATCHING_TIMESLOTS_START = 'FETCH_NO_MATCHING_TIMESLOTS_START';
export const FETCH_NO_MATCHING_TIMESLOTS_SUCCESS = 'FETCH_NO_MATCHING_TIMESLOTS_SUCCESS';
export const FETCH_NO_MATCHING_TIMESLOTS_ERROR = 'FETCH_NO_MATCHING_TIMESLOTS_SUCCESS';
export const REMOVE_NO_MATCHING_TIMESLOT_START = 'REMOVE_NO_MATCHING_TIMESLOT_START';
export const REMOVE_NO_MATCHING_TIMESLOT_SUCCESS = 'REMOVE_NO_MATCHING_TIMESLOT_SUCCESS';
export const REMOVE_NO_MATCHING_TIMESLOT_ERROR = 'REMOVE_NO_MATCHING_TIMESLOT_ERROR';
export const REMOVE_NO_MATCHING_TIMESLOT_RESET = 'REMOVE_NO_MATCHING_TIMESLOT_RESET';
export const JOIN_WAITLIST_START = 'JOIN_WAITLIST_START';
export const JOIN_WAITLIST_SUCCESS = 'JOIN_WAITLIST_SUCCESS';
export const JOIN_WAITLIST_ERROR = 'JOIN_WAITLIST_ERROR';
export const REMOVE_WAITLIST_START = 'REMOVE_WAITLIST_START';
export const REMOVE_WAITLIST_SUCCESS = 'REMOVE_WAITLIST_SUCCESS';
export const REMOVE_WAITLIST_ERROR = 'REMOVE_WAITLIST_ERROR';
export const REMOVE_WAITLIST_START_SCHOOL_DIR = 'REMOVE_WAITLIST_START_SCHOOL_DIR';
export const REMOVE_WAITLIST_SUCCESS_SCHOOL_DIR = 'REMOVE_WAITLIST_SUCCESS_SCHOOL_DIR';
export const REMOVE_WAITLIST_ERROR_SCHOOL_DIR = 'REMOVE_WAITLIST_ERROR_SCHOOL_DIR';
export const GET_ADDED_APPLICATION_PROGRAM = 'GET_ADDED_APPLICATION_PROGRAM';
export const SYNC_ADDED_PROGRAM_SAVED_PROGRAM = 'SYNC_ADDED_PROGRAM_SAVED_PROGRAM';

// TODO: This constant is used for special cases regarding La Guardia school
export const LA_GUARDIA_DBN = '03M485';
export const INSTUMENTAL_MUSIC_PROGRAM_CODE = 'M80L';

export const MT_PROGRAM_SCIENCE = 'Science';
export const MT_PROGRAM_COMPUTER_OR_MATH = 'Computer/Math';
export const MT_PROGRAM_CREATIVE_WRITING = 'Creative Writing/Journalism';
export const MT_PROGRAM_ATHLETICS = 'Athletics';
export const MT_PROGRAM_DANCE = 'Dance';
export const MT_PROGRAM_DRAMA = 'Drama';
export const MT_EXPRESSED_INTEREST_PROGRAMS = [MT_PROGRAM_SCIENCE, MT_PROGRAM_COMPUTER_OR_MATH, MT_PROGRAM_CREATIVE_WRITING, MT_PROGRAM_ATHLETICS, MT_PROGRAM_DANCE, MT_PROGRAM_DRAMA]
// export const MT_AUDITION_PROGRAMS = ['Art', 'Dance', 'Drama', 'Media', 'String Instruments', 'Wind Instruments', 'Vocal']
export const MT_AUDITION_PROGRAMS = ['Art', 'Media', 'String Instruments', 'Wind Instruments', 'Vocal']
